export default __webpack_public_path__ + "static/Scroll-Image---Commercial-Demolition-8db41c14ba4b45af683992e528eb0875.jpg";